import { render, staticRenderFns } from "./BookInformationSelector.vue?vue&type=template&id=8ba9c51e&scoped=true"
import script from "./BookInformationSelector.vue?vue&type=script&lang=js"
export * from "./BookInformationSelector.vue?vue&type=script&lang=js"
import style0 from "./BookInformationSelector.vue?vue&type=style&index=0&id=8ba9c51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba9c51e",
  null
  
)

export default component.exports